<template>
  <div class="dashboard-filter-bar">
    <!-- @todo create a preloading status -->
    <div class="columns md:space-x-4">
      <div class="column is-paddingless md:max-w-xl flex flex-col w-full space-y-2">
        <core-input
          v-model="filtersSelected.search"
          label="Tenant Name"
          placeholder="Search a tenant"
          class="w-full"
        />

        <core-input
          v-model="filtersSelected.unitNumber"
          label="Unit Number"
          placeholder="Search a unit"
          class="w-full"
        />

        <div
          v-if="role === roles.SUPER_ADMIN && role === roles.CS_ADMIN"
          class="form-inline select-container is-2-fullhd"
        >
          <core-select
            v-model="filtersSelected.overdue"
            label="Overdue"
            class="w-full"
          >
            <option
              selected
              value=""
            >
              All
            </option>
            <template v-for="status in filters.overdue">
              <option
                v-if="status"
                :key="status"
                :value="status"
              >
                {{ status }}
              </option>
            </template>
          </core-select>
        </div>
      </div>
      <div class="column w-full md:max-w-xs px-0 md:w-1/3 xl:w-1/5 flex-initial flex-col space-y-2 mt-4">
        <div class="form-inline select-container is-2-fullhd w-full lg:w-auto">
          <div class="field has-addons">
            <div class="control w-full">
              <button
                ref="applyBtn"
                class="
                  btn
                  h-10
                  w-full
                  bg-mine-shaft-900
                  dark:bg-mine-shaft-800
                  dark:hover:bg-mine-shaft-900
                  text-white
                  hover:text-white
                  hover:bg-mine-shaft-950
                  rounded-sm
                  border
                  border-mine-shaft-700
                  dark:border-mine-shaft-600"
                @click="applyAllFilters"
              >
                Apply Filters
              </button>
            </div>
          </div>
        </div>
        <button
          class="btn h-10 bg-gray-200 hover:bg-muted-300 dark:hover:bg-muted-700 dark:bg-muted-800 rounded-sm"
          @click="resetAllFilters"
        >
          Reset Filters
        </button>
        <button
          class="btn is-info text-white rounded-sm w-full h-10"
          @click="isShow = !isShow"
        >
          {{ isShow ? "Hide Filters" : "More Filters" }}
          <span class="icon is-small">
            <i :class="isShow ? 'fas fa-caret-up' : 'fas fa-caret-down'" />
          </span>
        </button>
      </div>
    </div>
    <transition name="slide">
      <div
        v-if="isShow"
        class="extra child space-y-4 border-b border-muted-300 dark:border-muted-600 pb-4 mb-4"
      >
        <!-- Auctions & Stages filters -->
        <div class="grid grid-cols-2 lg:grid-cols-4 gap-2">
          <core-input
            v-model="filtersSelected.auctionFrom"
            type="date"
            label="Auction Date From"
          />
          <core-input
            v-model="filtersSelected.auctionTo"
            type="date"
            label="Auction Date To"
          />
          <core-select
            v-model="filtersSelected.previous"
            label="Previous Stage"
          >
            <option
              selected
              value=""
            >
              All
            </option>
            <template v-for="status in filters.previous">
              <option
                v-if="status"
                :key="status"
                :value="status"
              >
                {{ status }}
              </option>
            </template>
          </core-select>
          <core-select
            v-model="filtersSelected.next"
            label="Next Stage"
          >
            <option
              selected
              value=""
            >
              All
            </option>
            <template v-for="status in filters.next">
              <option
                v-if="status"
                :key="status"
                :value="status"
              >
                {{ status }}
              </option>
            </template>
          </core-select>
        </div>

        <!-- Due Dates Filters -->
        <div class="grid grid-cols-2 gap-2 lg:w-1/2">
          <core-input
            v-model="filtersSelected.pastDueMin"
            type="number"
            label="Past Due Days Min"
            placeholder="From"
          />
          <core-input
            v-model="filtersSelected.pastDueMax"
            type="number"
            label="Past Due Days Max"
            placeholder="To"
          />
          <core-input
            v-model="filtersSelected.dueAmountMin"
            type="number"
            label="Due Amount Min"
            placeholder="From"
          />
          <core-input
            v-model="filtersSelected.dueAmountMax"
            type="number"
            label="Due Amount Max"
            placeholder="To"
          />
        </div>

        <!-- Lien Status Filters -->
        <div class="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <div class="column p-0">
            <p class="box-label">
              Lien Status
            </p>
            <div class="box w-full max-w-none">
              <label
                v-for="(val, propertyName) in filters.status"
                :key="propertyName"
                class="checkbox"
              >
                <input
                  v-model="filtersSelected.status"
                  type="checkbox"
                  :value="val.id"
                  @click="() => selectLien('isSelectedLien')"
                >
                {{ val.name }}
              </label>
            </div>
            <div class="btns flex justify-between w-full">
              <button
                class="bg-gray-200 hover:bg-muted-300 dark:hover:bg-muted-700 dark:bg-muted-800 rounded-sm"
                @click="clearAllLienStatus"
              >
                Clear All
              </button>
              <button
                class="btn is-info is-light"
                @click="selectAllLienStatus"
              >
                Select All
              </button>
            </div>
          </div>

          <div class="column p-0">
            <p class="box-label">
              Aging
            </p>
            <div class="box">
              <label
                v-for="val in filters.aging"
                :key="val"
                class="checkbox"
              >
                <input
                  v-model="filtersSelected.aging"
                  type="checkbox"
                  :value="val"
                  @click="() => selectLien('isSelectedAging')"
                >
                {{ val }}
              </label>
            </div>
            <div class="btns flex justify-between w-full">
              <button
                class="bg-gray-200 hover:bg-muted-300 dark:hover:bg-muted-700 dark:bg-muted-800 rounded-sm"
                @click="clearAllAging"
              >
                Clear All
              </button>
              <button
                class="btn is-info is-light"
                @click="selectAllAging"
              >
                Select All
              </button>
            </div>
          </div>

          <div class="column p-0">
            <p class="box-label">
              Locations
            </p>
            <div class="box">
              <div class="relative mb-2">
                <input
                  v-model="locationsFilterQuery"
                  class="small"
                  placeholder="Search"
                >

                <button
                  v-if="locationsFilterQuery !== ''"
                  class="absolute right-0 top-0 mt-1.5 mr-3 text-sm text-gray-400"
                  @click="locationsFilterQuery = ''"
                >
                  <i class="fa fa-times" />
                </button>
              </div>

              <label
                v-for="(val) in filteringLocations"
                :key="val[0]"
                class="checkbox"
              >
                <input
                  v-model="filtersSelected.location"
                  type="checkbox"
                  :value="val[0]"
                  @click="() => selectLien('isSelectedLocations')"
                >

                {{ val[1] }}
              </label>
            </div>
            <div class="btns flex justify-between w-full">
              <button
                class="btn bg-gray-200 hover:bg-muted-300 dark:hover:bg-muted-700 dark:bg-muted-800 rounded-sm"
                @click="clearLocations"
              >
                Clear All
              </button>
              <button
                class="btn is-info is-light"
                @click="selectLocations"
              >
                Select All
              </button>
            </div>
          </div>

          <div
            v-if="
              [roles.CS_ADMIN, roles.SUPER_ADMIN].includes(
                $store.state.user.role
              )
            "
            class="column p-0"
          >
            <p class="box-label">
              Customers
            </p>
            <div class="box">
              <div class="relative mb-2">
                <input
                  v-model="customerFilterQuery"
                  class="small"
                  placeholder="Search"
                >

                <button
                  v-if="customerFilterQuery !== ''"
                  class="absolute right-0 top-0 mt-1.5 mr-3 text-sm text-gray-400"
                  @click="customerFilterQuery = ''"
                >
                  <i class="fa fa-times" />
                </button>
              </div>

              <label
                v-for="(val, propertyName) in filteringCustomers"
                :key="propertyName"
                class="checkbox"
              >
                <input
                  v-model="filtersSelected.customer"
                  type="checkbox"
                  :value="val[0]"
                  @click="() => selectLien('isSelectedCustomers')"
                >
                {{ val[1] }}
              </label>
            </div>
            <div class="btns flex justify-between w-full">
              <button
                class="btn bg-gray-200 hover:bg-muted-300 dark:hover:bg-muted-700 dark:bg-muted-800 rounded-sm"
                @click="clearCustomers"
              >
                Clear All
              </button>
              <button
                class="btn is-info is-light"
                @click="selectCustomers"
              >
                Select All
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { Roles } from '../../../constants';
import DashboardService from '../../../services/dashboard.service';

const dashboard = new DashboardService();

const defaultLienStatusList = {
  1: 'DMTC',
  2: 'AAA',
  3: 'MOVE',
  6: 'HOLD'
};

export default {
  components: {
    'core-input': () => import('@/components/core/Input'),
    'core-select': () => import('@/components/core/Select')
  },
  data() {
    return {
      roles: Roles,
      filters: {},
      locationsListLocalManager: [],
      isShow: false,
      isSelectedLien: false,
      isSelectedHold: false,
      selectedHoldData: [],
      isSelectedAging: false,
      isSelectedLocations: false,
      isSelectedCustomers: false,
      defaultStatuses: [],
      role: this.$store.state?.user?.role,
      filtersSelected: {
        status: [],
        location: [],
        customer: [],
        aging: [],
        search: '',
        unitNumber: '',
        overdue: '',
        next: '',
        previous: '',
        auctionFrom: '',
        auctionTo: '',
        dueAmountMax: '',
        dueAmountMin: '',
        pastDueMax: '',
        pastDueMin: ''
      },
      locationsFilterQuery: '',
      customerFilterQuery: ''
    };
  },
  computed: {
    filteringLocations() {
      return this.filters.location.length > 0 && this.locationsFilterQuery.length > 0
        ? this.filters.location.filter((item) => item[1].toLowerCase().includes(this.locationsFilterQuery.toLowerCase()))
        : this.filters.location;
    },
    filteringCustomers() {
      return this.filters.customer.length > 0 && this.customerFilterQuery.length > 0
        ? this.filters.customer.filter((item) => item[1].toLowerCase().includes(this.customerFilterQuery.toLowerCase()))
        : this.filters.customer;
    }
  },
  watch: {
    isShow() {
      if (this.isShow) {
        // @todo why?
        // this.resetAllFilters();
      }
    }
  },
  async mounted() {
    const organization = this.$store.state.organization || {};
    const locationList = this.$store.state?.locationsList || [];
    let organizationUuid = '';
    // @todo unused?
    this.locationsListLocalManager = locationList.map((item) => ({
      name: item.name,
      id: item.uuid
    }));
    if (this.$store.state.user.role === Roles.SUPER_ADMIN) {
      organizationUuid = organization && Object.keys(organization).length
        ? organization.uuid
        : '';
    } else if (this.$store.state?.user?.role === Roles.CS_ADMIN) {
      organizationUuid = this.$store.state?.organization?.uuid;
    } else {
      organizationUuid = this.$store.state.locationsList[0].organization_uuid;
    }

    const { data } = await dashboard
      .getAllAvialableFilters(organizationUuid)
      .catch((error) => {
        console.log(error);
      });

    this.filters = data.result;
    this.filters.customer = Object.entries(data.result.customer).sort((a, b) => a[1].localeCompare(b[1]));
    this.filters.location = Object.entries(data.result.location).sort((a, b) => a[1].localeCompare(b[1]));

    // eslint-disable-next-line no-restricted-syntax
    for (const val in data.result.status) {
      if (defaultLienStatusList[val]) {
        this.filtersSelected.status.push(val);
        this.defaultStatuses.push(val);
      }
    }

    this.$store.commit('setDashboardFilters', {
      status: this.defaultStatuses
    });

    const selected = this.$store.getters['TableState/getDashboardTableFilters'];

    if (selected) {
      this.filtersSelected = {
        ...this.filtersSelected,
        ...selected
      };
    }
    this.$events.fire('filters-set', this.filtersSelected);
  },
  methods: {
    selectLien(key) {
      this.isSelectedLien = true;
      this[key] = false;
    },
    clearAllLienStatus() {
      this.isSelectedLien = false;
      this.filtersSelected.status = [];
    },
    selectAllLienStatus() {
      this.isSelectedLien = true;
      this.filtersSelected.status = [...Object.keys(this.filters.status)];
    },
    clearAllAging() {
      this.isSelectedAging = false;
      this.filtersSelected.aging = [];
    },
    selectAllAging() {
      this.isSelectedAging = true;
      this.filtersSelected.aging = [...this.filters.aging];
    },
    clearLocations() {
      this.isSelectedLocations = false;
      this.filtersSelected.location = [];
    },
    selectLocations() {
      this.isSelectedLocations = true;
      this.filtersSelected.location = [...this.filters.location.map(([id]) => id)];
    },
    clearCustomers() {
      this.isSelectedCustomers = false;
      this.filtersSelected.customer = [];
    },
    selectCustomers() {
      this.isSelectedCustomers = true;
      this.filtersSelected.customer = [...this.filters.customer.map(([id]) => id)];
    },
    applyAllFilters() {
      this.$events.fire('filters-set', this.filtersSelected);
      this.$store.commit('TableState/setDashboardTableFilters', this.filtersSelected);
    },
    resetAllFilters() {
      this.filtersSelected = {
        status: this.defaultStatuses,
        location: [],
        customer: [],
        aging: [],
        search: '',
        unitNumber: '',
        overdue: '',
        next: '',
        previous: '',
        auctionFrom: '',
        auctionTo: '',
        dueAmountMax: '',
        dueAmountMin: '',
        pastDueMin: '',
        pastDueMax: ''
      };

      this.$events.fire('filters-set', this.filtersSelected);
      this.$store.commit('TableState/setDashboardTableFilters', this.filtersSelected);
    }
  }
};
</script>
<style scoped lang="scss">
.mr-fb {
  margin-top: 34px;
  margin-left: 20px;
}
.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 400px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
.btns {
  padding-top: 9px;
  align-items: flex-end;
  button {
    margin-bottom: 5px;
    border: 0px;
    padding: 4px 0px;
    width: 100px;
    cursor: pointer;
    @apply rounded;
  }
}
.ml-10 {
  margin-left: 10px;
}
.ml-30 {
  margin-left: 30px !important;
}
.pl-0 {
  padding-left: 0;
}
.mt-12 {
  margin-top: 12px;
}
.box {
  @apply p-3 pt-2;

  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  height: 138px;
  margin: 0;
  &-btns {
    padding-left: 0px;
    margin: 0;
    flex-direction: row;
    justify-content: space-between;
    max-width: 230px;
    button {
      padding: 4px 6px;
    }
  }
  label {
    font-size: 14px;
    margin-bottom: 8px;
  }
}
.box-label {
  font-weight: 400;
  font-size: 0.8rem;
  margin-bottom: 8px;
}
.extra {
  width: 100%;
  height: auto;

  .row {
    display: flex;
    flex-wrap: wrap;
  }
  .input_box {
    display: flex;
  }
  .field {
    display: flex;
    flex-direction: column;
  }
}
.label__inner {
  margin-left: 15px;
}
.dashboard-filter-bar {
  display: flex;
  width: 100%;
  flex-direction: column;

  .columns {
    margin-bottom: 0.75rem;
    height: auto;

    .column {
      display: flex;

      .control-button {
        background-color: rgba(var(--primary-gray), 1);

        &:hover {
          background-color: rgba(var(--gray), 1);
        }

        a.button {
          background: transparent;
          border: 0;
          padding: 1rem;
          height: 56px;
        }
      }
    }
  }
}
</style>
